import React, { Component } from "react";
import httpRequest from "apis/httpRequest";
import changeImgSrc from "../../util/ImgSrcHandle";
import { CMS_CONTENT_URL } from "../../actions/types";
// import Breadcrumb from 'antd/lib/breadcrumb';
// import { Link } from 'react-router-dom'
// 详细的cms信息
class CmsInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      site: "",
      pubDate: "",
      JsonHtml: ""
    };
  }
  // [to-do] 不同cms的图片img路径不一样 有的是resource/xxx.png 有的是/resource/xxx.png
  // 导致图片处理不一样
  componentDidMount() {
    if (this.props.location.state) {
      this.setState({
        title: this.props.location.state.data.title,
        site: this.props.location.state.data.site,
        pubDate: this.props.location.state.data.pubDate
      });
    }
    const link = this.props.location.pathname.split("page=")[1];
    httpRequest.get(`${CMS_CONTENT_URL}?link=${link}&type=content`).then(res => {
      let htmlText = res.data.Text || res.data.html;
      if (htmlText) {
        // let theSlashIndex = 0;
        // if(link.indexOf("cms.gcp.edu.cn") !== -1 || link.indexOf("ccnl.scut.edu.cn") !== -1){
        //   theSlashIndex = link.lastIndexOf("/", link.length-1); // 从http://的斜杠后面开始找最后一个/
        // }else{
        //   theSlashIndex = link.indexOf("/", 8); // 从http://的斜杠后面开始找第一个/
        // }
        // const linkRootUrl = link.substring(0, theSlashIndex);
        let JsonHtml = changeImgSrc(htmlText, link);

        let path=link.substring(0,link.lastIndexOf('/')+1);
        JsonHtml=JsonHtml.replace(/(href=")(resource)/g,'$1'+path+'$2')

        this.setState({ JsonHtml: JsonHtml });
      }
    });
  }
  // <Breadcrumb>
  //   <Breadcrumb.Item><Link to={ BASE_LINK }>首页</Link></Breadcrumb.Item>
  //   <Breadcrumb.Item><Link to={ CMSALL_LINK }>新闻中心</Link></Breadcrumb.Item>
  //   <Breadcrumb.Item>新闻详情</Breadcrumb.Item>
  // </Breadcrumb>
  render() {
    return (
      <React.Fragment>
        {/* <div className="breadcrumb">返回</div> */}
        <div style={{ background: "#fff" }}>
          <div className="cms-detail">
            <div className="site">{this.state.site}</div>
            <div className="pubDate">{this.state.pubDate}</div>
            <div
              className="title"
              dangerouslySetInnerHTML={{ __html: this.state.title }}
            />
            <div
              style={{ fontSize: 16, lineHeight: "24px" }}
              dangerouslySetInnerHTML={{ __html: this.state.JsonHtml }}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CmsInfo;
